import bus from '../../utils/bus';
import {
  USER,
  TICKET_CRM
} from '../../utils/constants';
import {
  hasPermission
} from '@/utils';
import enums from '@/utils/enums';
export default {
  data() {
    return {
      profileItem: {
        email: '',
        telephone: '',
        cellphone: ''
      },
      profileLoading: false,
      profileError: false,
      profileForm: {
        loading: false,
        error: false
      },
      profileState: {
        unsavedChanges: false
      }
    };
  },
  methods: {
    async getUser(onlyUpdateState = false) {
      if (this.profileLoading) return;
      try {
        this.profileLoading = true;
        this.profileError = false;

        let data = {};
        const imobmeData = this.$store.getters[USER.GET_IMOBME_DATA];

        if (imobmeData) {
          data = imobmeData;
        } else {
          const url = `${process.env.AUTH_API_URL}/user/getUser`;
          const params = {
            username: this.user.username,
            userRole: this.user.userRole,
            ignoreUser: 1
          };
          const result = await this.requestService(url, 'GET', { params });
          if (result) {
            this.$store.commit(USER.MUTATE_IMOBME_DATA, result.client);
            data = result.client;
          } else {
            throw new Error('Not valid user response');
          }
        }

        if (onlyUpdateState) return;

        this.profileItem.email = data.email;

        this.profileItem.telephone = data.telephone ?
          this.formatPhoneObjectToString(data.telephone) :
          '';

        this.profileItem.cellphone = data.cellphone ?
          this.formatPhoneObjectToString(data.cellphone) :
          '';
      } catch (err) {
        this.profileError = true;
      } finally {
        this.profileLoading = false;
      }
    },
    async updateUser(fromHome = true) {
      if (!hasPermission(enums.clientUpdateProfiles))
        throw new Error('Does not have permission');
      try {
        this.profileForm.loading = true;
        this.profileForm.error = false;
        let result;
        if (this.isSyndic) {
          const userRaw = Object.assign({}, this.$store.getters[USER.GET_USER]);
          const rawTelephone = Object.assign({}, userRaw.telephone);
          const rawCellphone = Object.assign({}, userRaw.cellphone);
          const oldEmail = userRaw.email;
          const newEmail = this.profileItem.email;
          const telephone = this.formatPhoneStringToObject(
            this.profileItem.telephone
          );
          const cellphone = this.formatPhoneStringToObject(
            this.profileItem.cellphone
          );
          userRaw.email = newEmail;
          userRaw.telephone = telephone;
          userRaw.cellphone = cellphone;

          const {
            lastUpdate,
            fullName,
            clientCode,
            document,
            birthday,
            identity,
            username,
            profile,
            tenantId,
            ...user
          } = userRaw;

          const body = {
            userRole: user.userRole,
            ticketCrmToken: this.$store.getters[TICKET_CRM.GET_TOKEN],
            ...user
          };

          const url = `${process.env.AUTH_API_URL}/user/updateUser`;
          result = await this.requestService(url, 'POST', {data: body});
          if (result) {
            if (this.profileState.unsavedChanges)
              this.profileState.unsavedChanges = false;

            bus.$emit('snackbar:open', {
              text: 'Cadastro atualizado com sucesso!',
              color: 'green'
            });

            const changedData = this.getContactUpdatedData({
              cellphone,
              rawCellphone,
              telephone,
              rawTelephone,
              oldEmail,
              newEmail
            });
            if (changedData) {
              const action = this.enums.logTraceActions[
                `profileChange${fromHome ? 'FromHome' : ''}`
              ];
              this.createTrace(action, changedData);
            }

            this.$store.commit(USER.MUTATE_USER, userRaw);
          }
        } else {
          const clientRaw = Object.assign({},
            this.$store.getters[USER.GET_IMOBME_DATA]
          );
          const rawTelephone = Object.assign({}, clientRaw.telephone);
          const rawCellphone = Object.assign({}, clientRaw.cellphone);
          const oldEmail = clientRaw.email;
          const newEmail = this.profileItem.email;
          const telephone = this.formatPhoneStringToObject(
            this.profileItem.telephone
          );
          const cellphone = this.formatPhoneStringToObject(
            this.profileItem.cellphone
          );
          clientRaw.email = newEmail;

          const {
            lastUpdate,
            fullName,
            clientCode,
            document,
            birthday,
            identity,
            ...client
          } = clientRaw;

          const body = {
            userRole: this.$store.getters[USER.GET_USER].userRole,
            user: {
              _id: this.$store.getters[USER.GET_USER]._id,
              email: newEmail
            },
            client,
            ticketCrmToken: this.$store.getters[TICKET_CRM.GET_TOKEN]
          };
          if (!body.client.telephone || Object.keys(telephone).length == 0) {
            body.client.telephone = {
              areaCode: '',
              ext: '',
              isActive: true,
              number: '',
              type: 'Residencial'
            };
          }
          if (Object.keys(telephone).length > 0) {
            body.client.telephone.number = telephone.number;
            body.client.telephone.areaCode = telephone.areaCode;
          }
          if (!body.client.cellphone || Object.keys(cellphone).length == 0) {
            body.client.cellphone = {
              areaCode: '',
              ext: '',
              isActive: true,
              number: '',
              type: 'Celular'
            };
          }
          if (Object.keys(cellphone).length > 0) {
            body.client.cellphone.number = cellphone.number;
            body.client.cellphone.areaCode = cellphone.areaCode;
          }
          const url = `${process.env.AUTH_API_URL}/user/updateUser`;
          result = await this.requestService(url, 'POST', {
            data: body,
            localErrorHandling: true
          });

          if (result) {
            if (this.profileState.unsavedChanges)
              this.profileState.unsavedChanges = false;

            bus.$emit('snackbar:open', {
              text: 'Cadastro atualizado com sucesso!',
              color: 'green'
            });

            const changedData = this.getContactUpdatedData({
              cellphone,
              rawCellphone,
              telephone,
              rawTelephone,
              oldEmail,
              newEmail
            });
            if (changedData) {
              const action = this.enums.logTraceActions[
                `profileChange${fromHome ? 'FromHome' : ''}`
              ];

              this.createTrace(action, changedData);
            }

            if (clientRaw.telephone) {
              clientRaw.telephone.number = telephone.number;
              clientRaw.telephone.areaCode = telephone.areaCode;
            }
            if (clientRaw.cellphone) {
              clientRaw.cellphone.number = cellphone.number;
              clientRaw.cellphone.areaCode = cellphone.areaCode;
            }
            this.$store.commit(USER.MUTATE_IMOBME_DATA, clientRaw);
          }
        }
      } catch (err) {
        this.handleAuthError(err);
        this.profileForm.error = true;
      } finally {
        this.profileForm.loading = false;
      }
    },
    getContactUpdatedData({
      cellphone,
      rawCellphone,
      telephone,
      rawTelephone,
      oldEmail,
      newEmail
    }) {
      const changedData = {};
      if (
        (Object.keys(cellphone).length > 0 && !rawCellphone) ||
        (Object.keys(cellphone).length == 0 &&
          Object.keys(rawCellphone).length > 0) ||
        (Object.keys(cellphone).length > 0 &&
          rawCellphone &&
          (cellphone.number != rawCellphone.number ||
            cellphone.areaCode != rawCellphone.areaCode))
      )
        changedData.cellphone = {
          old: rawCellphone || {},
          new: cellphone
        };
      if (
        (Object.keys(telephone).length > 0 && !rawTelephone) ||
        (Object.keys(telephone).length == 0 &&
          Object.keys(rawTelephone).length > 0) ||
        (Object.keys(telephone).length > 0 &&
          rawTelephone &&
          (telephone.number != rawTelephone.number ||
            telephone.areaCode != rawTelephone.areaCode))
      )
        changedData.telephone = {
          old: rawTelephone || {},
          new: telephone
        };
      if (oldEmail != newEmail)
        changedData.email = {
          old: oldEmail,
          new: newEmail
        };
      return Object.keys(changedData).length > 0 ? changedData : null;
    },
    getAddressUpdatedData({
      oldAddress,
      newAddress
    }) {
      const changedData = {};
      Object.keys(newAddress).forEach(key => {
        if (key == 'zipcode')
          newAddress[key] = newAddress[key].replace('-', '');
        if (oldAddress[key] != newAddress[key]) {
          if (!changedData.old) changedData.old = {};
          if (!changedData.new) changedData.new = {};
          changedData.old[key] = oldAddress[key];
          changedData.new[key] = newAddress[key];
        }
      });
      return Object.keys(changedData).length > 0 ? changedData : null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/modules/profile.js